<template>
  <div class="page-wrapper">
    <search-list
    @searchParams="search"
    :projectList="projectList"
    :typeList="typeList"
    :budgetCodeList="budgetCodeList"
    >
    </search-list>
    <div >
      <Button v-p="{api:'perGoalEstimation/update'}" type="primary" @click.stop="addN++" class="mb16">新增</Button>
      <Button v-p="{api:'perGoalEstimation/batchImport'}" type="primary" @click.stop="importN++" class="mb16" style="margin-left:10px">导入</Button>
    </div>
     <add
      :n="addN"
      @done="getSearchData"   
      :projectList="projectList"
      :typeList="typeList"
      :chaifenList="chaifenList"
      >
    </add>
    <modify
    :m="addM"
    @done="getSearchData"
    :projectList="projectList"
    :typeList="typeList"
    :chaifenList="chaifenList"
    :item='item'
    ></modify>

    <table-list
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    >
    </table-list>
    <import-file
    :i="importN"
    @done="getSearchData"
    ></import-file>
  </div>
</template>

<script>
import { getProjects } from 'api/common'
import SearchList  from './components/SearchList'
import ImportFile  from './components/ImportFile'
import TableList from 'components/TableList/index';
import Add from './components/Add'
import Modify from './components/Modify'
import { targetList , condition ,deleteTaregt , getType } from 'api/targetApi'
import {formatDateTime,formatMoney} from "../../../utils/format"

export default {
  components:{
    SearchList,
    TableList,
    Add,
    Modify,
    ImportFile
  },
  data(){
    return{
      item:{},
      addN:0,
      addM:0,
      importN:0,
      projectList:[],
      budgetCodeList:[],
      chaifenList:[
        {
          value:0,
          text:'按日'
        },
        // {
        //   value:1,
        //   text:'按月'
        // }
      ],
      page:1,
      limit:10,
      total:0,
      typeList:[],
      data:[],
      loading:false,
      current:1,
      columns:[
        {
          title:'项目名称',
          key: 'projectName',
          width: 200,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'类型',
          key: 'estimationTypeName',
          width: 100,
          align: 'center',
        },
        {
          title: ' '
        },
        {
          title:'费用项',
          key: 'itemName',
          width: 150,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'预算项',
          key: 'subjectName',
          width: 150,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'目标',
          key: 'targetAmount',
          width: 100,
          align: 'center',
          render:(h,params)=>{
            if (params.row['estimationType'] == 5) {
              return h('span',{},formatMoney(params.row['targetAmount'])+'%')
            }
            return h('span',{},formatMoney(params.row['targetAmount']))
          }
        },
        {
          title: ' '
        },
        {
          title:'拆分方式',
          key: 'incomeMethod',
          width: 100,
          align: 'center',
          render(h,params){
            return h('span', {}, params.row['incomeMethod'] === 0 ? '按日' : '按月');
          }
        },
        {
          title: ' '
        },
        {
          title:'单位',
          key: 'averageAmount',
          width: 100,
          align: 'center',
          render:(h,params)=>{
            if (params.row['estimationType'] == 5) {
              return h('span',{},formatMoney(params.row['averageAmount']) + '%');
            } else {
              return h('span',{},formatMoney(params.row['averageAmount']));
            }
          }
        },
        {
          title: ' '
        },
        {
          title:'开始日期',
          key: 'startDate',
          width: 110,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'结束日期',
          key: 'endDate',
          width: 110,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'创建人',
          key: 'createBy',
          width: 100,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title: '创建时间',
          align: 'center',
          key: 'createTime',
          width: 110,
          render: (h, params) => {
            return h('span', {}, this.format(params.row['createTime']))
          }
        },
        {
          title: ' '
        },
        {
          title: '操作',
          align: 'center',
          width: 100,
          fixed: 'right',
          render:(h,params)=>{
            return [
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'perGoalEstimation/update'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$nextTick( ()=> {
                      this.item = params.row
                      this.addM++;
                    })
                  }
                },
                style: {
                  marginRight: '10px'
                }
              }, '修改'),
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'perGoalEstimation/delete'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除目标',
                      content: '<p>确认删除本条目标？</p>',
                      onOk: () => {
                        const params2 = {
                          fid:params.row['fid']
                        }
                        deleteTaregt(params2)
                        .then( res => {
                          if(res.code === 0){
                            this.$Message.success('删除成功')
                            this.getSearchData();
                          }
                        })
                        .catch( err => {
                          this.$Message.info( '删除失败')
                        })
                        .finally( ()=> {
                          this.isShow = false
                        })
                      }
                    })
                  }
                }
              }, '删除')
            ]
          }
        },
        {
          title: ' '
        }
      ],
    }
  },
  created(){
    this.getProjectsData();
    this.getTypeData();
    // this.getSearchData();
  },
  computed:{
    searchListParams(){
      return
    }
  },
  methods:{
    getProjectsData(){
      getProjects()
      .then(res => {
        this.projectList = res.data;
      })
    },
    getTypeData(){
      getType()
        .then(res => {
          this.typeList = res.data;
        })
    },
    search(data){
      this.searchParams = data
      this.page=1
      this.current=1
      this.getSearchData();
    },
    getSearchData(){
      let params= {
        ...this.searchParams,
        page:this.page,
        limit:this.limit
      }
      targetList(params)
      .then( res => {
        this.data = res.data.rows
        // this.data.forEach( (ele,index)=>{
        //   if(ele.estimationType===4){
        //     ele.estimationName = '保底GOP'
        //   } else if(ele.estimationType===1){
        //     ele.estimationName = '成本目标'
        //   } else if(ele.estimationType===2){
        //     ele.estimationName = '收入目标'
        //   } else{
        //     ele.estimationName = ''
        //   }
        // })
        this.total = res.data.total
      })
    },
    changPage(n){
      this.current = n;
      this.page = n;
      this.getSearchData()
    },
    format(data, showTime = true) {
      if (!data) {
        return ''
      }
      return formatDateTime(data, showTime)
    }
  }
}
</script>

<style>

</style>
